// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c5-4";
export var closeButton = "_c5-6";
export var dismissButton = "_c5-3";
export var editImageWithAiContainer = "_c5-8";
export var imageUploadWrapper = "_c5-7";
export var misspelledWord = "_c5-5";
export var spellCheckContainer = "_c5-2";
export var spin = "_c5-1";
export var spinning = "_c5-0";